if (!customElements.get("announcement-bar-slider")) {
  customElements.define(
    "announcement-bar-slider",
    class SlideAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: true,
          breakpoints: {
            960: {
              slidesPerView: 3,
              spaceBetween: 24,
            }
          }
        };
        if (this.querySelector('.js-announcement-bar-slider').hasAttribute('data-autoplay')) {
          this.autoplayValue = this.querySelector('.js-announcement-bar-slider').getAttribute('data-autoplay');
          this.swiperOptions.autoplay = {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          };
          this.swiperOptions.speed = this.autoplayValue;
        }
        this.annoucementbarSlide = new Swiper(".js-announcement-bar-slider", this.swiperOptions);
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('li[data-action="toggle-logoCollection"]');

  menuItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      const handle = item.getAttribute('data-image');

      const logoCollections = document.querySelectorAll('.logo_collection');

      logoCollections.forEach(function (logo) {
        if (logo.getAttribute('data-image') === handle) {
          logo.style.display = 'block';
        } else {
          logo.style.display = 'none';
        }
      });
    });

    item.addEventListener('mouseleave', function () {
      const handle = item.getAttribute('data-image');
      const logoCollections = document.querySelectorAll('.logo_collection');

      logoCollections.forEach(function (logo) {
        if (logo.getAttribute('data-image') !== handle) {
          logo.style.display = 'none';
        }
      });
    });
  });

  const logoCollections = document.querySelectorAll('.logo_collection');
  logoCollections.forEach(function (logo) {
    logo.addEventListener('mouseenter', function () {
      logo.style.display = 'block';
    });
    logo.addEventListener('mouseleave', function () {
      const currentlyHoveredLi = document.querySelector('li[data-action="toggle-logoCollection"]:hover');
      if (!currentlyHoveredLi) {
        logo.style.display = 'none';
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const parentItems = document.querySelectorAll('.drawer-menu__parent-has-child');
  
  parentItems.forEach(function(parentItem) {
    parentItem.addEventListener('click', function() {
      this.classList.toggle('open');
    });
  });
});

$(window).on('load', function () {
  if ($('body').hasClass('template-search')) {
      var term = $(document).find('[data-terms]').data('terms');
      if (term) {
          var xhrSearch1;
          var xhrSearch2;
          var xhrSearch3;
          var url2 = '&resources[type]=collection';
          var url3 = '&resources[type]=article';
          var url4 = '&resources[type]=page';
          xhrSearch1 = jQuery.ajax({
              'url': "/search/suggest.json?q=" + term + url2,
              'type': 'GET',
              'dataType': 'json', // added data type
              'limit': 5,
              'success': function (response) {
                  console.log(response)
                  var innerContent = ''
                  var collectionSuggestions = response.resources.results.collections;
                  if (collectionSuggestions.length > 0) {
                      $(document).find('.search_results_count--collection').html(collectionSuggestions.length);
                      var innerContent = '';
                      collectionSuggestions.forEach(collection => {
                          innerContent += '<li class="Linklist__Item">';
                          innerContent += '<a href="' + collection.url + '" class="Link Link--primary">' + collection.title + '</a>';
                          innerContent += '</li>';
                      });
                      $(document).find('#Search_CollectionList .CollectionList').html(innerContent);
                  }
              }
          });
      }
  }
});

if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSlide extends HTMLElement {
      constructor() {
        super();
        this.swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: true,
          navigation: {
            nextEl: ".testimonial-button-next",
            prevEl: ".testimonial-button-prev",
          },
        };
        this.annoucementbarSlide = new Swiper(".js-testimonials-slider", this.swiperOptions);
      }
    }
  );
}
$(document).ready(function(){
  $(document).on('click', '.js-button-checkout', function (e) {
    e.preventDefault();
  
    var cart_attribute__field = $(this).closest('form').find('.cart-attribute__field.required');
    if (cart_attribute__field.length > 0) {
      var pass = false;
      cart_attribute__field.each(function( index ) {
        var input = $(this).find('input');
        if (input.val() != '') {
          pass = true;
        }else{
          pass = false;
        }
      });
      if (pass == true) {
        var params = {
            type: 'POST',
              url: '/cart/update.js',
            data: $('form[action="/cart"]').serialize(),
            dataType: 'json',
            success: function(data) { 
              window.location.href = "/checkout";
             }
          }
          $.ajax(params);
          return;
      } else {
        $('.cart-attribute__field.required').find('input').css('border-color', 'red');
        alert('Please enter the "Student Name" field and "Student Class" field');
        return false;
      }
    } else {
      window.location.href = "/checkout";
    }
  });
});
